/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import Breadcrumb from './Breadcrumb/index'
import Dropdown from 'DesignSystem/Dropdown/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/PreviewDocument/Content/Content/HtmlFile/Content/Content/Content/Actions/Upload/Content/Documents/Content/Patients/Content"
  
}) {
let threadPatientsValueData = fromData.useDataValue({ viewPath,
context: 'thread_patients',
})
let patientDocumentsPatientIdValueData = fromData.useDataValue({ viewPath,
context: 'patient_documents',
path: 'patient_id',
})
let onClick = fromHelpers.useOnChange({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Dropdown
  viewPath={`${viewPath}/Dropdown`}
 data="thread_patients"
 from={threadPatientsValueData}
 data="patient_documents.patient_id"
 selected={patientDocumentsPatientIdValueData}
 onClick={onClick}
 field="name"
 text="Select a patient"
 label={false}
 alignItems="stretch"
 textAlign="left"
 minWidth={150}
 maxWidth={250}
 width={250}
 height={100}
 flexGrow={0}
/>
<Breadcrumb
  viewPath={`${viewPath}/Breadcrumb`}
/>
</div>
{children}
</React.Fragment>)
}